export const express_interest_form = {
    basic_details: {
        title: "Your Details",
        field_names: {
            name: "name",
            email: "email",
            phone: "phone",
            country_code: "country_code",
            message: "message",
        },
        placeholders: {
            name: "Name",
            email: "Email",
            phone: "Phone Number",
            message: "Message",
        },
    },
} as const;

export const express_interest_form_error_strings = {
    required: "Required",
    invalid_email: "Invalid Email",
    submit_all: "Fill all required information",
};
